import { useState } from "react";
import { client } from "../net/client";
import { useSignal } from "../net/signal";
import { Overlay } from "./Overlay";
import { notify } from "./Dialog";
import { IRAN_CITIES, countryOptions, placeLabel } from "../game/place";

/**
 * کشور و شهرِ خودم — اختیاری.
 *
 * از خودِ بازیکن می‌گیریم، نه از IP، و تا کلیدِ «نشان بده» روشن نباشد به کسی
 * نمی‌رسد. شهر فقط برای ایران و از فهرست است (نه متنِ آزاد) تا دشنام و شوخی
 * به میز نرسد. همین برگه در نسخه‌ی موبایل هم هست (PlaceV3).
 */
export function PlaceRow() {
  const country = useSignal(client.country);
  const city = useSignal(client.city);
  const show = useSignal(client.showPlace);
  const [open, setOpen] = useState(false);
  const label = placeLabel({ country, city });
  return (
    <>
      <div className="plate row place-row">
        <span className="val">
          <Pin />
          <span>{label ? label + (show ? "" : " — پنهان") : "کشور و شهر: نگفته‌ای"}</span>
        </span>
        <button className="btn ghost" style={{ width: "auto", paddingInline: 16 }} onClick={() => setOpen(true)}>
          {label ? "ویرایش" : "بگو"}
        </button>
      </div>
      {open && <PlaceEditor onClose={() => setOpen(false)} />}
    </>
  );
}

function Pin() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M20 10c0 6-8 12-8 12S4 16 4 10a8 8 0 0 1 16 0Z" /><circle cx="12" cy="10" r="3" />
    </svg>
  );
}

function PlaceEditor({ onClose }: { onClose: () => void }) {
  const [country, setCountry] = useState(client.country.value);
  const [city, setCity] = useState(client.city.value);
  const [show, setShow] = useState(client.showPlace.value);
  const [busy, setBusy] = useState(false);
  const options = countryOptions();
  const save = async () => {
    if (busy) return;
    setBusy(true);
    const err = await client.setPlace(country, country === "IR" ? city : "", show && country !== "");
    setBusy(false);
    if (err) { notify(err === "network" ? "به سرور نرسید؛ دوباره امتحان کن" : "نشد؛ دوباره امتحان کن"); return; }
    notify(country ? (show ? "ثبت شد؛ هم‌بازی‌ها می‌بینند" : "ثبت شد؛ فقط خودت می‌بینی") : "پاک شد");
    onClose();
  };
  return (
    <Overlay label="کشور و شهر" className="placepick" onClose={onClose}>
      <div className="stack" style={{ gap: 12, width: "min(92vw, 360px)" }}>
        <div style={{ fontSize: 18, fontWeight: 700, color: "var(--gold-bright)" }}>کشور و شهر</div>
        <div className="muted">اختیاری است. از نشانیِ اینترنتت چیزی حدس نمی‌زنیم؛ فقط چیزی که خودت این‌جا بگویی.</div>
        <label className="stack" style={{ gap: 4 }}>
          <span className="muted">کشور</span>
          <select value={country} onChange={(e) => { setCountry(e.target.value); if (e.target.value !== "IR") setCity(""); }}>
            <option value="">— نمی‌گویم —</option>
            {options.map((o) => <option key={o.code} value={o.code}>{o.fa}</option>)}
          </select>
        </label>
        {country === "IR" && (
          <label className="stack" style={{ gap: 4 }}>
            <span className="muted">شهر</span>
            <select value={city} onChange={(e) => setCity(e.target.value)}>
              <option value="">— نمی‌گویم —</option>
              {IRAN_CITIES.map((c) => <option key={c} value={c}>{c}</option>)}
            </select>
          </label>
        )}
        <label className="check">
          <input type="checkbox" checked={show} disabled={!country} onChange={(e) => setShow(e.target.checked)} />
          <span>به هم‌بازی‌ها و تماشاچی‌ها نشان بده</span>
        </label>
        <div className="muted">اگر خاموش باشد، هیچ‌کس جز خودت نمی‌بیند. هر وقت بخواهی پاکش کن.</div>
        <div className="row" style={{ gap: 8 }}>
          <button className="btn" style={{ flex: 1 }} disabled={busy} onClick={() => void save()}>ثبت</button>
          <button className="btn ghost" style={{ flex: 1 }} onClick={onClose}>بستن</button>
        </div>
      </div>
    </Overlay>
  );
}
